var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "card mb-3", class: _vm.banner ? "card-promotion" : "" },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "col-12 text-center banner-wrapper",
            class: _vm.banner ? "ob1-tag ob1-tag-primary" : "",
          },
          [_c("strong", { domProps: { textContent: _vm._s(_vm.banner) } })]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body p-1" },
        [
          _c("internet-and-mobile-card-content", {
            attrs: {
              visual: _vm.mobileOffer.visual,
              "detail-link": _vm.mobileOffer.detailLink,
              price: _vm.mobileOffer.price,
              "offer-name": _vm.mobileOffer.name,
              "background-visual": _vm.mobileOffer.backgroundVisual,
              "prefix-wrapper": "mobile",
            },
          }),
          _vm._v(" "),
          _c("card-content-separator", {
            attrs: { "icon-class": "icon-Add text-primary3" },
          }),
          _vm._v(" "),
          _c("internet-and-mobile-card-content", {
            attrs: {
              visual: _vm.internetOffer.visual,
              "detail-link": _vm.internetOffer.detailLink,
              price: _vm.internetOffer.price,
              "offer-name": _vm.internetOffer.name,
              "background-visual": _vm.internetOffer.backgroundVisual,
              "prefix-wrapper": "internet",
            },
          }),
          _vm._v(" "),
          _c("card-content-separator", {
            attrs: { "icon-class": "icon-equal text-primary" },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-row mb-1 justify-content-between" },
            [
              _c(
                "div",
                { staticClass: "price-wrapper" },
                [
                  _c("price", {
                    attrs: {
                      price: _vm.packSummary.price.priceInCents,
                      "initial-price":
                        _vm.packSummary.price.initialPriceInCents,
                      "show-by-month": _vm.packSummary.price.showByMonth,
                      "show-from": _vm.packSummary.price.showFrom,
                      duration: _vm.packSummary.price.duration,
                      "price-details": _vm.packSummary.price.priceDetails,
                      "price-label": _vm.packSummary.price.priceLabel,
                      "show-promo-duration": _vm.showPromoDuration,
                      "show-end-of-promotion-price":
                        _vm.showEndOfPromotionPrice,
                      "show-until-end-of-promo": _vm.showUntilEndOfPromo,
                      "show-children-promotion-price":
                        _vm.showChildrenPromotionPrice,
                      "show-promo-duration-first-months":
                        _vm.showPromoDurationFirstMonths,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("bouton", {
                ref: "redirectButton",
                attrs: {
                  label: _vm.packSummary.buttonCta.label,
                  href: _vm.summaryButtonHref,
                  "is-button": _vm.summaryButtonIsButton,
                  "animation-duration": _vm.summaryButtonDataTimer,
                  "tms-category": _vm.packSummary.buttonCta.tms.category,
                  "tms-action": _vm.packSummary.buttonCta.tms.action,
                  "tms-label": _vm.packSummary.buttonCta.tms.label,
                },
                on: { click: _vm.handleButtonClick },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ToastSnackBar", { ref: "internetAndMobileToastSnackBar" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }